import _ from 'lodash'

const seo = {
  computed: {
    seo: {
      get () {
        if (typeof this.pageApiData === 'undefined') return

        return this.pageApiData.seo
      }
    }
  },
  methods: {
    $_setSeoHtml ({ title, meta }) {
      document.title = title
      _.forEach(meta, this.$_setMeta)
    },
    $_setMeta (tag) {
      const existingTag = document.querySelector(`meta[name="${tag.name}"]`)

      const workingTag = existingTag === null
        ? document.createElement('meta')
        : existingTag

      _.forEach(_.keys(tag), attribute => {
        workingTag.setAttribute(attribute, tag[attribute])
      })

      if (existingTag === null) document.head.appendChild(workingTag)
    }
  },
  watch: {
    seo: {
      handler (data) {
        if (typeof data !== 'undefined') this.$_setSeoHtml(data)
      },
      immediate: true,
      deep: true
    }
  }
}

export default seo
